import React from 'react';
import './frontproduct.css';
import { useNavigate } from "react-router-dom";
// const YourComponent = () => {

const ProductShowcase = () => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/brand");  // Navigate within React Router
    window.scrollTo(0, 0); // Ensure the page opens at the top
  };
  const products = [
    { id: 1, name: 'Sughandh', image: require('../../assets/08.webp'), color: 'red' },
    { id: 2, name: 'Kesar', image: require('../../assets/07.webp'), color: 'purple' },
    { id: 3, name: 'Silver', image: require('../../assets/05.webp'), color: 'green' },
    { id: 4, name: 'Platinum', image: require('../../assets/03.webp'), color: 'black' },
    { id: 5, name: 'Khushboo', image: require('../../assets/04.webp'), color: 'red' },
    { id: 6, name: 'Mehak', image: require('../../assets/06.webp'), color: 'red' },
    { id: 7, name: 'Diamond', image: require('../../assets/02.webp'), color: 'red' },
    { id: 8, name: 'Premium', image: require('../../assets/09.webp'), color: 'red' },
    { id: 9, name: 'Gold', image: require('../../assets/01.webp'), color: 'red' }
  ];

  const ProductCard = ({ product }) => (
    <div className="bsa-product-card">
      <div className="bsa-product-image-container">
        <img src={product.image} alt={product.name} className="bsa-product-image" />
      </div>
      <div className="bsa-product-name">{product.name}</div>
    </div>
  );

  return (
    <div className="bsa-product-showcase-container">
      <div className="bsa-carousel-container">
        <div className="bsa-rice-carousel owl-carousel owl-theme">
          {products.map(product => (
            <div key={product.id} className="bsa-carousel-item">
              <ProductCard product={product} />
            </div>
          ))}
        </div>
        <div className="bsa-view-more-container">
        <button className="bsa-view-more-btn" onClick={handleRedirect}>
      View More
    </button>
        </div>
      </div>
    </div>
  );
};

export default ProductShowcase;
